import { DiscussionsLinkedTypes } from "types/enum";

import { isInPortal } from "utilities/portal/portal";

export const getDiscussionTypeName = (linkedType: DiscussionsLinkedTypes, plural = false) => {
    if (linkedType === DiscussionsLinkedTypes.OwnerPayments && isInPortal({ owner: true })) {
        return plural ? "Invoices" : "Invoice";
    }
    if (linkedType === DiscussionsLinkedTypes.ClientUpdate && isInPortal({ owner: true })) {
        return plural ? "Project Updates" : "Project Update";
    }

    switch (linkedType) {
        case DiscussionsLinkedTypes.All:
            return "All";
        case DiscussionsLinkedTypes.Selections:
            return plural ? "Selections" : "Selection";
        case DiscussionsLinkedTypes.SelectionOptions:
            return plural ? "Selection Options" : "Selection Option";
        case DiscussionsLinkedTypes.ChangeOrders:
            return plural ? "Change Orders" : "Change Order";
        case DiscussionsLinkedTypes.PurchaseOrders:
            return plural ? "Purchase Orders" : "Purchase Order";
        case DiscussionsLinkedTypes.Warranty:
            return plural ? "Warranties" : "Warranty";
        case DiscussionsLinkedTypes.Bids:
            return plural ? "Bids" : "Bid";
        case DiscussionsLinkedTypes.DailyLogs:
            return plural ? "Daily Logs" : "Daily Log";
        case DiscussionsLinkedTypes.ScheduleItems:
            return plural ? "Schedule Items" : "Schedule Item";
        case DiscussionsLinkedTypes.ToDos:
            return plural ? "To-Dos" : "To-Do";
        case DiscussionsLinkedTypes.OwnerPayments:
            return plural ? "Invoices" : "Invoice";
        case DiscussionsLinkedTypes.Documents:
            return plural ? "Documents" : "Document";
        case DiscussionsLinkedTypes.Videos:
            return plural ? "Videos" : "Video";
        case DiscussionsLinkedTypes.LegacyBills:
            return plural ? "Bills" : "Bill";
        case DiscussionsLinkedTypes.PhotoDocs:
            return plural ? "Photos" : "Photo";
        case DiscussionsLinkedTypes.BidPackages:
            return plural ? "Bid Packages" : "Bid Package";
        case DiscussionsLinkedTypes.Receipts:
            return plural ? "Receipts" : "Receipt";
        case DiscussionsLinkedTypes.CreditMemos:
            return plural ? "Credit Memos" : "Credit Memo";
        case DiscussionsLinkedTypes.Bills:
            return plural ? "Bills" : "Bill";
        case DiscussionsLinkedTypes.Jobsite:
            return plural ? "Jobs" : "Job";
        case DiscussionsLinkedTypes.ClientUpdate:
            return plural ? "Client Updates" : "Client Update";
        case DiscussionsLinkedTypes.Deposit:
            return plural ? "Deposits" : "Deposit";
        case DiscussionsLinkedTypes.Task:
            return plural ? "Tasks" : "Task";
        case DiscussionsLinkedTypes.Specification:
            return plural ? "Specifications" : "Specification";
        case DiscussionsLinkedTypes.PlanPage:
            return plural ? "Plans" : "Plan";
        default:
            return plural ? "Unknown Types" : "Unknown Type";
    }
};
